export default __webpack_public_path__ + "static/media/blood-clot.47a509a1.svg";